import React, { Fragment } from "react";

export const ConnectedNetwork = (props: { network: string[] }) => (
  <Fragment>
    <i className="fa fa-check-square"></i>
    <span>{ props.network[1] }</span>
    <br />
  </Fragment>
)
